import React from 'react';
import * as Styles from './wh.style';
import { Icon } from 'semantic-ui-react';
import CustomButton from 'components/common/custom-button';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { P } from 'components/reusable-css';
import { sizesData } from 'constants/wh';

const WHSize = ({ size, sizePrice, onClick, selected, index, length }) => {
  const { t } = useTranslation();
  const userAccount = useSelector((state) => state.user.account);
  return (
    <Styles.Size selected={selected}>
      <Styles.SizesContainer length={length} index={index} selected={selected} onClick={() => onClick(size)}>
        <Styles.Popular showTag={size?.featured}>
          <div className="flex-container">
            <Icon name="star" size="small" color="white" />
            <P>{t('wh/create.step2_string3')}</P>
          </div>
        </Styles.Popular>
        <div>
          <Styles.NameContainerDiv>
            <Styles.NameContainer>
              <Styles.Name>{t(`wh/create.${size?.i18n_key}`)}</Styles.Name>
            </Styles.NameContainer>
          </Styles.NameContainerDiv>
          <Styles.Price>
            <Trans
              i18nKey="wh/create.step2_string7"
              values={{
                price: Math.trunc(sizePrice?.price_monthly_usd),
                currency_symbol: userAccount?.account_currency_symbol,
              }}
              components={{
                price: <Styles.PriceUnit />,
                monthly: <Styles.PerMonth />,
              }}
            />
            <Styles.Separator />
            <Trans
              i18nKey="wh/create.step2_string8"
              values={{
                price: Math.trunc(sizePrice?.price_yearly_usd),
                currency_symbol: userAccount?.account_currency_symbol,
              }}
              components={{
                price: <Styles.PriceUnit />,
                monthly: <Styles.PerMonth />,
              }}
            />
          </Styles.Price>
          <Styles.Features>
            {sizesData?.map((val, i) => (
              <Styles.Conatiner key={i}>
                <Styles.Heading>{t(val.heading)} </Styles.Heading>
                {val?.description?.map((text, i) => (
                  <Styles.Feature key={i}>
                    {t(text.text, { websites: size.websites, storage: size.storage })}
                  </Styles.Feature>
                ))}
              </Styles.Conatiner>
            ))}
          </Styles.Features>
        </div>
        <Styles.FeaturesButton>
          <CustomButton
            isIcon={selected ? <Icon name="check" /> : <Icon name="angle right" />}
            title={selected ? 'wh/create.step2_string22' : 'wh/create.step2_string23'}
            buttonStyles={{
              width: '100%',
              backgroundColor: selected ? '#FF7300' : '#cfcfcf',
              fontWeight: 'bold',
              color: selected ? 'white' : 'black',
              textTransform: 'capitalize',
            }}
          />
        </Styles.FeaturesButton>
      </Styles.SizesContainer>
    </Styles.Size>
  );
};
export default WHSize;
